import { getTheme, IStyle, mergeStyleSets } from "@fluentui/react";

const spacingSize = 10;
const smallCoefficient = 1;
const mediumCoefficient = 2;
const largeCoefficient = 3;

export enum Spacing {
    None,
    XSmall,
    Small,
    Medium,
    Large,
    XLarge
}

export const msGridRowClass = 'ms-Grid-row';
export const msGridColClass = 'ms-Grid-col';
export const bwjLargeSpacingClass = 'bwj-spacing-large';
export const bwjMediumSpacingClass = 'bwj-spacing-medium';
export const bwjSmallSpacingClass = 'bwj-spacing-small';

export const useLayoutStyles = () => {
    const theme = getTheme();

    const card: IStyle = {
        backgroundColor: theme.palette.white,
        backgroundClip: 'padding-box',
        padding: spacingSize * largeCoefficient,
        marginBottom: spacingSize * largeCoefficient,
        borderRadius: 2,
       '-webkit-box-shadow': '0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)',
       boxShadow: '0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)',
    };

    const formSection: IStyle = {
        '& .ms-Grid-row.bwj-spacing-large:last-child': {
            marginBottom: spacingSize * -largeCoefficient,
        },
        '& .ms-Grid-row.bwj-spacing-medium:last-child': {
            marginBottom: spacingSize * -mediumCoefficient,
        },
        '& .ms-Grid-row.bwj-spacing-small:last-child': {
            marginBottom: spacingSize * -smallCoefficient,
        },
    };

    const formSectionHeading: IStyle = {
        fontWeight: 600,
    };

    const row: IStyle = {
        '&.bwj-spacing-large > .ms-Grid-col': {
            paddingBottom: spacingSize * largeCoefficient,
        },
        '&.bwj-spacing-medium > .ms-Grid-col': {
            paddingBottom: spacingSize * mediumCoefficient,
        },
        '&.bwj-spacing-small > .ms-Grid-col': {
            paddingBottom: spacingSize * smallCoefficient,
        },
    };

    return mergeStyleSets({
        card,
        formSection,
        formSectionHeading,
        row,
    });
}